<!-- Translated: skip -->
<template>
  <div class="component">
    <Timeline :steps="timelineSteps"></Timeline>
    <LanguageSwitcher type="dropdown" v-if="!$store.state.isOnSite" :show-title="false" @pickedlanguage="reMount" />

    <h1>Dina bokade liftkort</h1>
    <!--<h1 v-if="people[currentIndex]">Åkare {{currentIndex + 0}} klar gå vidare till nästa</h1>-->

    <div class="people max-width">
    <div :class="{person: true, opened: (currentIndex === index), completed: person.guideFullyCompleted}" v-for="(person, index) in people" v-if="person.guideCompleted">

      <div class="blue-bar" @click="setActive(currentIndex !== index ? index : -1)">
        <div class="inner">
          <span><icon name="green-check" :scale="1.8" /></span>
          <span class="name">Åkare {{index + 1}}:</span>
          <span class="package" v-if="days(person.age).find(function(day) {return day.value === person.days})">
            {{days(person.age).find(function(day) {return day.value === person.days}).title}} /
            {{ages[person.age]}}
          </span>
          <span class="price">
            <span><b>Pris:</b> {{(person.price + (person.keycardPrice ? person.keycardPrice : 0)) | currency}}</span>
          </span>
          <span class="change" @click.stop="setActive(index)">
            <!--<button class="small white tight"><icon name="edit-blue" :scale="1.2" /> Ändra</button>-->
            <span class="delete" @click.stop="remove(index)">
              <button class="small white tight"><icon name="trash" :scale="1.2" /></button>
        </span>
          </span>
        </div>
        <span v-if="currentIndex !== index" class="show-or-close">
          <div class="text">
            Visa
          </div>
          <div class="arrow">
            <icon v-if="person.guideFullyCompleted" name="chevron-down-green" :scale="1.9" />
            <icon v-if="!person.guideFullyCompleted" name="chevron-down-blue" :scale="1.9" />
          </div>
        </span>
        <span v-if="currentIndex === index" class="show-or-close">
          <div class="text">
            Stäng
          </div>
          <div class="arrow">
            <icon v-if="person.guideFullyCompleted" name="chevron-down-blue-up" :scale="1.9" />
              <icon v-if="!person.guideFullyCompleted" name="chevron-down-blue-up" :scale="1.9" />
          </div>
        </span>
      </div>

      <transition name="animate-filter">

        <div class="ski-pass-user-wrapper" v-show="(currentIndex === index)">
          <div class="inner-width">

            <div :class="'content'">

              <label>Ålder</label>

              <div>
                {{ages[person.age]}} &nbsp; <a href="#" style="text-decoration:underline" @click.stop.prevent="goToUser(currentIndex)"> ändra </a>
              </div>

            </div>

            <div :class="'content ' + (person.age ? '' : 'disabled')">

              <label>Antal dagar</label>
              <div>
                {{days(person.age).find(function(day) {return day.value === person.days}).title}} &nbsp; <a href="#" style="text-decoration:underline" @click.stop.prevent="goToUser(currentIndex)"> ändra </a>
              </div>

            </div>

            <div :class="'content'" v-if="person.refill">

              <label>Ditt keycardnummer</label>

              <div>
                {{ person.cardNumber }} &nbsp; <a href="#" style="text-decoration:underline" @click.stop.prevent="goToUser(currentIndex)"> ändra </a>
              </div>

            </div>

          </div>
        </div>

      </transition>

    </div>
    </div>

    <div class="max-width align-right">
      <div class="products">
        <div class="heading-products">Sammanställning</div>

          <div class="sum-bar">
            <div class="inner" style="text-align:right;">
        Totalt:
        <b>
          {{
            sum | currency
          }}
        </b>
          </div>
        </div>
    </div>
      </div>

    <div class="center button-confirm space-3 ">
      <button v-if="nextIndex" @click="next()">Gå vidare till nästa åkare</button>
      <button v-if="!nextIndex" class="small white border big" @click="addPerson()" :disabled="!validate()">Lägg till ny åkare</button>
      <span v-if="!nextIndex" style="margin-left:15px;margin-right:15px;"> ... eller ... </span>
      <button v-if="!nextIndex" @click="doSkipass()" :disabled="!validate()">Slutför bokning</button>
      <!--<span v-if="nextIndex" style="margin-left:15px;margin-right:15px;"> ... eller ... </span>
      <button class="small white border" v-if="nextIndex" @click="doSkipass()">Lägg i varukorg</button>-->
    </div>

  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import Timeline from '@/components/components/Timeline';
import FilterListItem from '@/components/parts/Accomodation/List/Filter/FilterListItem';

import LanguageSwitcher from '@/components/components/LanguageSwitcher';

import Dropdown from '@/components/components/Dropdown';

import skipassTimelineSteps from '@/mixins/skipassTimelineSteps';

import API from '@/classes/API';

import moment from 'moment';

import checkdigit from 'checkdigit';

export default {
  data() {
    return {
      nextIndex: 0,
      currentIndex: 0,
      person: {},
      ages: {
        children: 'Barn',
        youths: 'Ungdom',
        adults: 'Vuxen',
        seniors: 'Senior',
      },
      titles: {},
      daysRemote: null,
      categories: {},
      validStartDates: [],
      allAddons: [],
      daysOriginal: [],
      options: [{
        value: 'children',
        title: 'Barn',
        subtitle: '(0-6 år)',
      }, {
        value: 'youths',
        title: 'Ungdom',
        subtitle: '(7-17 år)',
      }, {
        value: 'adults',
        title: 'Vuxen',
        subtitle: '(18-64 år)',
      }, {
        value: 'seniors',
        title: 'Senior',
        subtitle: '(65+ år)',
      }],
      pattern: '####-####-####-####-####-#',
      placeholder: '0000-0000-0000-0000-0000-0',
    };
  },
  mixins: [skipassTimelineSteps],
  components: {
    Timeline,
    FilterListItem,
    Dropdown,
    LanguageSwitcher,
  },
  async mounted() {
    const years = this.$i18n.t('general.years'); // eslint-disable-line
    this.options[0].subtitle = `${this.SITE_CONFIG.skipass.ages.children} ${years}`;
    this.options[1].subtitle = `${this.SITE_CONFIG.skipass.ages.youths} ${years}`;
    this.options[2].subtitle = `${this.SITE_CONFIG.skipass.ages.adults} ${years}`;
    this.options[3].subtitle = `${this.SITE_CONFIG.skipass.ages.seniors} ${years}`;

    if (this.SITE_CONFIG.skipass.parents_enabled) {
      this.options.push({
        value: 'parents',
        title: 'Föräldrakort',
        subtitle: 'Kan delas av föräldrar',
      });
      this.ages.parents = 'Föräldrar';
    }

    const { data, keycard, titles } = await API.get(`skipass/list?only-season=${this.$route.query.onlyseason}`);
    this.daysRemote = data;
    this.keycardObject = keycard;
    this.titles = titles;

    const completed = this.people.filter(person => person.guideCompleted);
    const fullyCompleted = this.people.filter(person => person.guideFullyCompleted);
    this.nextIndex = completed.length;
    this.currentIndex = fullyCompleted.length;

    if (completed.length === this.people.length) {
      this.nextIndex = 0;
    }

    if (!completed.length) {
      if (this.people.length) {
        this.$router.replace({ name: 'ski pass person', query: this.$route.query, params: { person: '0' } });
      } else {
        this.$router.push({ name: 'ski pass overview', query: this.$route.query });
      }
    }
  },
  computed: {
    people() {
      return this.$store.state.cart.skipasses.filter(skipass => skipass.type !== 'SKIPASS-ACCO');
    },
    keycardOptions() {
      return [
        {
          title: '01',
          value: '01',
        }, {
          title: '30',
          value: '30',
        },
      ];
    },
    sum() {
      /* eslint-disable */
      return this.people.reduce((a, person) => {
        return a + person.price + (person.keycardPrice ? person.keycardPrice : 0);
      }, 0);
    },
    steps() {
      const steps = [];
      const $this = this;
      this.$store.state.cart.skipasses.forEach((person, index) => {
        const no = index + 1;
        const p = {
          title: (person.name || `Åkare ${no}`),
          complete: 0,
        };
        if (person.guideCompleted) {
          p.complete = 2;
        }
        steps.push(p);
      });
      steps.push({
        title: 'Bekräfta',
        complete: 0,
      });
      return steps;
    },
  },
  methods: {
    ...mapMutations([
      'openModal',
      'confirmSkiPass',
      'addSkiPassPeople',
      'completeSkipassGuides',
      'closeModal',
    ]),
    validate() {
      let validated = false;

      this.$store.state.cart.skipasses.forEach((person) => {
        if (!person.age) {
          validated = false;
          return;
        }
        if (!person.days) {
          validated = false;
          return;
        }
        if (person.refill) {
          if (!this.validateKeycardNumber(person)) {
            validated = false;
            return;
          }
        }

        validated = true;
      });

      return validated;
    },
    updatePrice(days) {
      const person = this.people[this.currentIndex];
      const index = this.$store.state.cart.skipasses.indexOf(person);
      const $days = this.days(person.age);
      const $day = $days.filter(day => day.value === days);
      this.$store.state.cart.skipasses[index].days = days;
      this.$store.state.cart.skipasses[index].price = Math.round(parseFloat($day[0].price));
    },
    changedDate(v) {
      this.updatePrice(v.value);
    },
    daysLabel(age, no) {
      const days = this.days(age).filter(day => day.value === no);
      if (days.length) {
        return days[0].title
      }
      return days;
    },
    setAge(person, option) {
      if (person.age) {
        person.age = null;
      } else {
        person.age = option.value // eslint-disable-line
      }
      this.updatePrice(person.days);
    },
    addPerson() {
      this.addSkiPassPeople({
        peopleCount: 1,
        append: true,
      });
      this.completeSkipassGuides();
      let next = this.people.length - 1;

      this.$router.push({ name: 'ski pass person', query: this.$route.query, params: { person: next } });
    },
    remove(index) {
      const $this = this;
      this.openModal(['GeneralModal', {
        title: 'Är du säker?',
        content: `Vill du verkligen radera åkare ${index + 1}?`,
        buttons: [
          {
            title: 'Ja',
            class: 'small',
            click: () => {
              $this.currentIndex = 0;

              let indexToRemove = -1;
              let iterator = -1;
              $this.$store.state.cart.skipasses.forEach((skipass, i) => {
                if (skipass.type !== 'SKIPASS-ACCO') {
                  iterator += 1;

                  if (iterator === index) {
                    indexToRemove = i;
                  }
                }
              });

              $this.$store.state.cart.skipasses.splice(indexToRemove, 1);

              const completed = this.people.filter(person => person.guideCompleted);

              if (!completed.length) {
                if (this.people.length) {
                  this.$router.replace({ name: 'ski pass person', query: this.$route.query, params: { person: '0' } });
                } else {
                  this.$router.push({ name: 'ski pass overview', query: this.$route.query });
                }
              }

              $this.closeModal();
            },
          },
          {
            title: 'Nej',
            class: 'small white border',
            click: () => {
              $this.closeModal();
            },
          },
        ],
      }]);
    },
    setActive(item) {
      this.currentIndex = item;
    },
    next() {
      this.$router.replace({ name: 'ski pass person', query: this.$route.query, params: { person: this.nextIndex } });
    },
    goToUser(index) {
      this.$router.push({ name: 'ski pass person', query: this.$route.query, params: { person: index } });
    },
    doSkipass() {
      this.openModal(['SkiPassConfirm']);
    },
    dateRange(person) {
      let start = moment(person.startDate).format('D MMMM');
      let end = moment(person.startDate).add((person.days - 1), 'days').format('D MMMM');
      return `${start} - ${end}`;
    },
    validateKeycardNumber(person) {
      const fullNumber = `${person.cardPrefix}${person.cardNumber}`.replace(/-/g, '');
      const validated = fullNumber ? checkdigit.mod10.isValid(fullNumber) : false;
      return fullNumber.length === 23 && validated;
    },
    errorKeycardNumber(person) {
      const fullNumber = `${person.cardPrefix}${person.cardNumber}`.replace(/-/g, '');
      const validated = fullNumber ? checkdigit.mod10.isValid(fullNumber) : false;
      return fullNumber.length === 23 && !validated;
    },
    days(localAge) {
      const days = [];

      if (this.daysRemote) {
        const category = localAge;
        let age = {
          children: 'children',
          youths: 'youths',
          adults: 'adults',
          parents: 'parents',
          seniors: 'seniors',
        };
        age = age[category];

        if (typeof age === 'undefined') {
          return this.daysOriginal;
        }

        let i;

        /* eslint-disable */
        let seasonSeparator = false;
        let specialSeparator = false;

        for (i in this.daysRemote) {
          let day = this.daysRemote[i][age];

          if (!day || !Number.isInteger(day.days)) {
            continue;
          }

          let title = this.titles[i];

          if (!title) {
            continue;
          }

          let price = Math.round(parseFloat(day.price));

          if (day.is_season && !seasonSeparator) {
            seasonSeparator = true;
            days.push({
              title: '',
              subtitle: '',
              price1: '',
              price: '',
              marked: false,
              separator: true,
              value: '',
            });
          }

          if (!day.variant && !specialSeparator) {
            specialSeparator = true;
            days.push({
              title: '',
              subtitle: '',
              price1: '',
              price: '',
              marked: false,
              separator: true,
              value: '',
            });
          }

          days.push({
            title,
            subtitle: '',
            price1: `${price}:-`,
            price,
            marked: false,
            value: i,
          });
        }
        /* eslint-ensable */


        return days;
      }

      return this.daysOriginal;
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.dropdown-keycard-wrapper
  position: relative;
  top: -10px

.small-dropdown
  width: 80px
  display: inline-block;
  position: relative;
  top: 3px

.component
  background-color #EBF5F8
  position: relative;
  & > .wrapper
    background-color white
    +max-mobile()
      background: transparent

.people
  border-radius: 2px;

.max-width
  max-width 749px
  margin 0 auto
  position: relative;
  &.align-right
    text-align: right;

.person
  margin-bottom 15px

  .inner-width
    max-width 1100px
    margin 0 auto
    padding 30px 0
    display none
  .ski-pass-user-wrapper
    background-color: #fff

.blue-bar
  width 100%
  border-radius 2px
  background-color #005580
  padding: 8px 14px 6px
  color white
  text-transform uppercase
  font-size 11px
  cursor pointer
  position relative
  padding-right: 110px;
  +max-mobile()
    border-radius: 0px

  .icon--green-check
    margin-bottom 5px
  .inner
    //max-width 480px
    padding 0 15px
    margin 0 auto
    .name
      united-heavy()
      font-size 15px
      color #ffffff
    .name,
    .package,
    .level,
    .right,
    .price
      display inline-block
      margin-right 20px
      position: relative;
      top: 2px
    .change
      display: inline-block;
      +max-mobile()
        position: relative;
        top: 2px
    .right
      float right
    .price
      font-weight: normal
      b
        //font-size: 15px;
        font-weight: bold;

.blue-bar
  .show-or-close
    position absolute
    right 0
    top 0
    height 38px
    +max-mobile()
      height: 100%
    .text
      font-size 11px
      font-weight bold
      padding-right: 12px
      display inline-block
      margin-top -1px
    .arrow
      width 49px
      height 39px
      line-height: 38px
      display inline-block
      background-color rgba(255, 255, 255, 0.8)
      text-align: center;
      position: relative;
      right: -1px
      +max-mobile()
        height: 100%
  .opened
    .show-or-close
      .arrow
        background-color rgba(255, 255, 255, 1)

.person.opened
  .inner-width
    display block
    background-color: #fff

.person.completed
  .blue-bar
    background-color green-desaturated

.person
  &.opened
    &.completed
      .blue-bar
        background-color: deep-sea-blue
h1
  text-transform none
  font-size 26px
  +max-mobile()
    font-size: 22px
    margin-bottom: 10px

.flex
  display flex
  padding-bottom space-3
  //justify-content center
  .control
    margin-left 15px
    margin-right 15px
    width 200px
    &:last-child
      width calc(100% - 400px)
    .label
      font-size 11px
      font-weight bold
      color black
    .input
      input()
      &.error
        border-color warning

.addon--inner-width
  background-color #f0f7f9
  box-shadow inset 0 0 12px 0 rgba(0, 0, 0, 0.08)

h4
  uppercase()

.content
  margin-bottom: 18px

.addon-list
  display flex
  flex-wrap wrap
  padding 5px
  & > *
    width 255px
    border-radius 2px
    background-color #ffffff
    box-shadow 0 0 8px 0 rgba(0, 0, 0, 0.14)
    margin-right 18px
    display flex
    border solid 2px white
    &.active
      border-color #c7dcb7
    .image
      width 76.6px
      height 70.9px
      border-radius 2px
      background-color rgba(225, 239, 243, 0.3)
      background-image url('https://static.booking.branasgruppen.se/static/img/helmet.png')
      background-size 40%
      background-repeat no-repeat
      background-position center
    .content
      h4
        font-family Interstate
        font-size 12px
        font-weight bold
        color #262626
        uppercase()

.space-3
  margin space-3
  +max-mobile()
    margin-top: 0px

.products
  background-color white
  tr
    td
      padding 10px
      font-size 13px
      font-weight 300
      color #262626
      border-bottom solid 1px rgba(191, 217, 225, 0.5)
      &.price
        text-align right
    &.total
      td
        font-size 12px
        color #9e9e9e
        &.price
          font-size 18px
          color #262626

.filter-list-item
  display inline-flex
  margin-right 3px
  margin-bottom 3px

.sum-bar
  font-size 12px
  font-weight bold
  letter-spacing -0.2px
  color #262626
  font-weight: 300
  uppercase()
  .inner
    max-width 1100px
    margin 0 auto
    padding-top 10px
    padding-bottom 10px
    padding-right: 6px
    +max-mobile()
      margin-right: 15px
      padding-top: 10px
      font-size: 11px
    b
      font-size 16px
      font-weight bold
      color #262626
      +max-mobile()
        font-size 14px

button
  &.white
    &.border
      &.big
        padding: 13px 20px;
        position: relative;
        top: -3px;
        top: -3px;
        font-size: 11px;

.button-confirm
  background-color: #fff
  margin: 20px 0px
  padding-top: 20px
  &.space-3
    +max-mobile()
      margin: 0px
      margin-top: 20px
  span
    display: none
  button
    display: inline-block;
    font-size: 12px
    padding: 8px 10px 4px 10px
    display: inline-block;
    margin-left: 20px
    +max-mobile()
      display: inline
      font-size: 10px
      position: relative;
      padding: 9px 12px 5px 12px
    &.white
      font-size: 10px
      padding: 9px 10px 6px 10px
      display: inline-block
      position: relative
      top: 1px
      margin-right: 10px
      &.border
        &.big
          font-size: 10px
          padding: 9px 10px 6px 10px
          display: inline-block
          position: relative
          top: 1px
          margin-right: 10px

          +max-mobile()
            font-size: 10px
            display: inline
            position: relative
            top: 1px
            margin-right: 10px
            padding: 10px 12px 8px 12px


.button
  margin 10px
  transition all 0.05s
  position relative
  padding 14px
  margin-top 0
  margin-bottom 10px
  +max-mobile()
    padding: 5px
    margin: 10px 6px 5px 6px
  &.wide
    font-size: 12px
    +max-mobile()
      padding: 8px 12px 8px 12px
      font-size: 11px
  &.has-description
    padding-top: 8px;
    padding-bottom: 7px;
    min-width: 115px;
    font-size: 12px
    margin-left: 0px
    margin-top: 0px
    margin-bottom: 3px
    +max-mobile()
      min-width: 90px
    span
      display block
      font-size 11px
      font-weight 300
      line-height 1.09
      text-align center
      color #161616
      text-transform none
      margin-top: 3px
    &.checked
      span
        color white
  &.checked:hover
    background-color #d68605
    border-color rgba(255, 255, 255, 0.7)
  &.checked:after
    content ""
    position absolute
    top -6px
    right -6px
    height 14px
    width 14px
    background-image url(https://static.booking.branasgruppen.se/static/svg/circle-green-minus.svg)
    background-size cover
  &.checked:hover:after
    background-image url(https://static.booking.branasgruppen.se/static/svg/circle-orange-minus.svg)

.person
  .inner-width
    max-width 450px
    margin 0 auto
    display: inline-block;
    padding: 15px 15px
.disabled
  disabled()

.products
  background-color white
  border-radius: 3px
  position: relative;
  box-shadow: 0 0 10px 0 rgba(0,0,0,0.1);
  width: auto
  min-width: 180px
  display: inline-block;
  text-align: left
  +max-tablet()
    margin-right: 10px
    margin-top: 6px
  .heading-products
    background-color: deep-blue
    padding: 8px 10px 6px 12px
    border-top-left-radius: 4px
    border-top-right-radius: 4px
    color: #fff
    text-transform: uppercase
    letter-spacing: 0.02em
    font-weight: bold
    font-size: 13px
    text-align: center;
    +max-tablet()
      font-size: 12px


input
  &.validated
    background-color: #5aa478;
    border-color #c7dcb7;
    color white
    uppercase()
  &.error
    border-color warning

input
  input()
  font-size: 13px;
  font-weight: 300;
  letter-spacing: 0.06em;
  color: rgba(38, 38, 38, 0.74);
  width 250px
  max-width 250px
  margin-top: 7px
  font-family: monospace;
  padding: 8px 10px 7px 10px;
  position: relative;
  top: 3px;

.language-switcher
  position absolute
  right 10px
  top 20px
  width: auto
  display inline-block
  padding: 5px 10px;

</style>



// WEBPACK FOOTER //
// SkiPassUserOverview.vue?5c7b1693